declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage(msg: string): void;
    };
  }
}

export const sendMessageToApp = (message: Record<string, string>) => {
  window.ReactNativeWebView &&
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
};
